module.exports = __webpack_public_path__ + "static/media/hikkoshi.f0e92956.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/myaccount/Dashboard/hikkoshi.svg
 ** module id = 1328
 ** module chunks = 0
 **/